export const getPlacementCardStyles = (/* theme */) => ({
  mmaRefreshedPlacementCardRoot: {
    display: 'flex',
    flexDirection: 'column',
    // flex: 1,
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'border-box',
    overflow: 'hidden',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
    borderRadius: 8,
    background: '#fff',
    margin: 'auto',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },
  mmaPlacementCardRoot: {
    display: 'flex',
    flexDirection: 'column',
    // flex: 1,
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
    borderRadius: 5.11,
    background: '#fff',
    margin: 'auto',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },
  mmaPlacementCardDisabled: {
    opacity: 0.5,
  },
});
